import { Select } from '@bigcommerce/big-design';

const COUNTRIES = [
	{ value: 'United States', content: 'United States' },
	{ value: 'Canada', content: 'Canada' },
];

export default function CountriesDropdown(props) {
	const { getValue, setValue } = props;

	return (
		<Select
			filterable={true}
			options={COUNTRIES}
			value={getValue('country')}
			onOptionChange={(value) => setValue('country', value)}
			placement={'bottom-start'}
			required
		/>
	);
}
